import React from 'react';
import CreateToolPage from '../components/ToolsSection/CreateToolModal';

const CreateTool = () => {
  return <CreateToolPage />;
};

export default CreateTool;
